import Vue from "vue/dist/vue.js";
import Vuex from "vuex";
import App from "./App";
import VueMeta from "vue-meta";
import router from "./router/index";
import axios from "./config/axios";
import VueAxios from "vue-axios";
import i18n from "./i18n/index";
import store from "./storage/index";
import { mask } from "vue-the-mask";
import VeeValidate, {Validator} from "vee-validate";
import Logger from "./modules/Logger";
import VueCarousel from 'vue-carousel';
import VueScrollTo from 'vue-scrollto';
import AsyncComputed from 'vue-async-computed';
import Tabs from 'vue-tabs-component';
import VModal from 'vue-js-modal';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

Raven.config('https://dcc4512bf1e942aaaa83e234f5d7bcf4@sentry.kredit24.kz/2',{
        release: '1.0.0',
        environment: process.env.NODE_ENV
    })
    .addPlugin(RavenVue, Vue)
    .install();


import * as components from "./components";
import filters from "./modules/filters";
import validators from './modules/validator'

for (let validator in validators){
    Validator.extend(validator, validators[validator]);
}
for (let component in components) {
  Vue.component(component, components[component]);
}
for (let filter in filters) {
    Vue.filter(filter, filters[filter]);
}

Vue.use(VueMeta);
Vue.directive("mask", mask);
Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(VueCarousel);
Vue.use(VueScrollTo);
Vue.use(AsyncComputed);
Vue.use(Tabs);
Vue.use(VModal);

Vue.use(VeeValidate, {
  i18n: i18n,
  i18nRootKey: "validation",
  locale: "ru",
  events: "change"
});

let ActionLogger = new Logger();

Object.defineProperty(Vue.prototype, "$logger", {
  get: function() {
    return ActionLogger;
  }
});


/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  components: { App },
  template: "<App/>"
});
